import React, { useState, useEffect } from "react";
import { useStateContext } from "../contexts/ContextProvider";
import StripeContainer from "../components/StripeGateway/StripeContainer";
import Footer from "../components/Footer/Footer";

import axios from "axios";

const Submission = () => {
  const { channels, getAllChannels } = useStateContext();
  const [showForm, setShowForm] = useState(false);
  const [link, setLink] = useState("");
  const [category, setCategory] = useState("");
  const [email, setEmail] = useState("");
  const [skipFees, setSkipFees] = useState(null);
  const [index, setIndex] = useState(-1);
  const [numberOfSkipline, setNumberOfSkipline] = useState(-1);
  const [code, setCode] = useState("");

  const body = {
    amount: skipFees * 100,
    description: `Skip the line for ${category}`,
    category,
    index,
    numberOfSkipline,
    code: code,
  };

  const handleLinkChange = (e) => {
    setLink(e.target.value);
  };

  const handleCategoryChange = (e) => {
    setCategory(e.target.selectedOptions[0].label);
    setSkipFees(parseFloat(e.target.value));
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  useEffect(() => {
    getAllChannels();
  }, []);

  const handleCodeChange = async (e) => {
    setCode(e.target.value);

    try {
      axios
        .get(
          `${process.env.REACT_APP_BACKEND_API_SERVER}/check-promo-code/skipline/${e.target.value}`
        )
        .then(
          (response) => {
            console.log(response);
            const result = response.data.found;
            console.log(result);
            if (result === true) {
              setSkipFees(0);
            } else {
              const index = channels.findIndex(
                (item) => item.name === category
              );
              setSkipFees(parseFloat(channels[index].skipLine));
            }
          },
          (error) => {
            alert(error);
          }
        );
    } catch (error) {
      alert(error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (link.includes("spotify") && link.includes("track")) {
      try {
        const data = {
          email: email,
          category: category,
          sLink: link,
        };
        console.log(data);

        const response = await axios(
          {
            method: "post",
            url: `${process.env.REACT_APP_BACKEND_API_SERVER}/submit`,
            data: data,
            mode: "no-cors",
          },
          { withCredentials: true }
        );

        const res = response.data;
        console.log(res);
        if (response.status === 200) {
          // Ask for skipping the line request
          setIndex(res.index);
          setNumberOfSkipline(res.skipline);
          setShowForm(true);
        } else {
          alert(res.message);
        }
      } catch (error) {
        const errorMessage = error.response.data.message;
        alert(errorMessage);
      }
    } else {
      alert("Invalid Spotify track URL, please try again.");
    }
  };

  return (
    <>
      <div className="SubForm p-3">
        <form
          onSubmit={(e) => {
            handleSubmit(e);
          }}
        >
          <div className="block p-3 w-full rounded-lg shadow-lg bg-transparent border-1 border-indigo-900">
            {showForm ? (
              <>
                <StripeContainer
                  skipline={true}
                  body={body}
                  url={`${process.env.REACT_APP_BACKEND_API_SERVER}/skipline`}
                  message={`Congrats, you just skip the line to the top of ${category} contest channel!`}
                />
              </>
            ) : (
              <>
                <div className="flex justify-center items-center">
                  <img
                    src="/images/vs.png"
                    className="w-1/4 h-auto mb-8"
                    alt="SoundOff Logo"
                  />
                </div>

                <div className="flex text-center justify-center items-center">
                  <h1 className="text-white font-bold text-2xl mb-8 uppercase">
                    Skip the Line
                  </h1>
                </div>
                <div className="form-group mb-6">
                  <input
                    value={link}
                    required
                    onChange={(e) => {
                      handleLinkChange(e);
                    }}
                    className="form-control block
                    w-full
                    px-3
                    py-1.5
                    text-base
                    font-normal
                    bg-black 
                    border-2 border-indigo-600 text-white
                    bg-clip-padding
                    rounded
                    transition
                    ease-in-out
                    m-0
                  focus:border-green-600 focus:outline-none"
                    id=""
                    placeholder="Song Link (Spotify)"
                  />
                </div>
                <div className="form-group mb-6">
                  <input
                    type="email"
                    value={email}
                    required
                    onChange={(e) => {
                      handleEmailChange(e);
                    }}
                    className="form-control block
                    w-full
                    px-3
                    py-1.5
                    text-base
                    font-normal
                    bg-black 
                    border-2 border-indigo-600 text-white
                    bg-clip-padding
                    rounded
                    transition
                    ease-in-out
                    m-0
                  focus:border-green-600 focus:outline-none"
                    id=""
                    placeholder="Email address"
                  />
                </div>

                <div className="form-group mb-6">
                  <select
                    required
                    onChange={(e) => {
                      handleCategoryChange(e);
                    }}
                    className="form-control block
                    w-full
                    px-3
                    py-1.5
                    text-base
                    font-normal
                    bg-black 
                    border-2 border-indigo-600 text-white
                    bg-clip-padding
                    rounded
                    transition
                    ease-in-out
                    m-0
                  focus:border-green-600 focus:outline-none"
                  >
                    <option value="" disabled selected>
                      Choose a channel
                    </option>
                    {channels &&
                      channels.map((cat) => (
                        <option
                          value={cat.skipLine}
                          name={cat.name}
                          key={cat.id}
                        >
                          {cat.name}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="px-6 pb-6 text-center">
                  <p className="text-white font-bold text-lg">
                    ${skipFees !== null ? skipFees : " ..."}
                  </p>
                </div>

                <div className="form-group mb-6">
                  <input
                    type="text"
                    value={code}
                    disabled={category === ""}
                    onChange={(e) => {
                      handleCodeChange(e);
                    }}
                    className={`${
                      category !== ""
                        ? "bg-black"
                        : "bg-gray-800 cursor-not-allowed"
                    }
                    form-control block
                    w-full px-3 py-1.5 text-base font-normal                  
                    border-2 border-indigo-600 text-white
                    bg-clip-padding rounded transition ease-in-out  m-0
                  focus:border-green-600 focus:outline-none`}
                    id=""
                    placeholder="Promo Code (Optional)"
                  />
                </div>

                <button
                  type="submit"
                  className="
                  w-full
                  px-6
                  py-3
                  bg-blue-600
                  text-white
                  font-semibold
                  text-md
                  leading-tight
                  rounded
                  shadow-md
                  hover:bg-blue-700 hover:shadow-lg
                  focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0
                  active:bg-blue-800 active:shadow-lg
                  transition
                  duration-150
                  ease-in-out"
                >
                  Submit
                </button>
              </>
            )}
          </div>
        </form>
      </div>
      <Footer />
    </>
  );
};

export default Submission;
